import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import * as ScopesSelectors from './scopes.selectors';
import * as ScopesActions from './scopes.actions';
import { Scopes } from '../../models/scope.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScopesFacade {
  public scopes: Observable<Scopes> = this._store.select(ScopesSelectors.scopes);
  public loading: Observable<boolean> = this._store.select(ScopesSelectors.loading);

  constructor(
    private _store: Store,
  ) {}

  public getScopes(): void {
    this._dispatch(ScopesActions.getScopes());
  }

  public setScopes(scopes: Scopes): void {
    this._dispatch(ScopesActions.setScopes({ scopes }));
  }

  private _dispatch(action: Action): void {
    this._store.dispatch(action);
  }
}
